import { FC } from 'react'
import {
  ExerciseStep,
  ExerciseType,
  OnResponseSubmit,
  StepResponse,
} from '../../../types/Exercise'
import { SocialComponent } from '../../../common/utils/feed'
import Image from '../Image'
import Player from '../Player'
import TextExercise from '../TextExercise'
import MultipleChoice from '../MultipleChoice'
import ScaleExercise from '../ScaleExercise'
import ChallengeExercise from '../ChallengeExercise'
import MotivationExercise from '../MotivationExercise'

interface ExerciseComponentProps {
  exercise: ExerciseStep
  onResponseSubmit: OnResponseSubmit
  stepResponses?: StepResponse[]
}

const ExerciseComponent: FC<ExerciseComponentProps> = ({
  exercise,
  onResponseSubmit,
  stepResponses = [],
}) => {
  const { type, data, id } = exercise
  const stepResponse = stepResponses?.find(
    (stepResponse) => stepResponse.stepId === id,
  )

  switch (type) {
    case ExerciseType.AUDIO:
      return (
        <Player
          id={id}
          data={data}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    case ExerciseType.OPEN_TEXT:
      return (
        <TextExercise
          id={id}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    case ExerciseType.MULTIPLE_CHOICE:
      return (
        <MultipleChoice
          id={id}
          data={data}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    case ExerciseType.SCALE:
      return (
        <ScaleExercise
          id={id}
          data={data}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    case ExerciseType.SOCIAL_MEDIA:
      return (
        <SocialComponent
          post={data}
          isExercise
          exerciseProps={{
            id,
            onResponseSubmit,
            stepResponse,
          }}
        />
      )
    case ExerciseType.CHALLENGE:
      return (
        <ChallengeExercise
          id={id}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    case ExerciseType.TEXT:
      return (
        <MotivationExercise
          id={id}
          data={data}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    case ExerciseType.IMAGE:
      return (
        <Image
          id={id}
          data={data}
          onResponseSubmit={onResponseSubmit}
          stepResponse={stepResponse}
        />
      )
    default:
      return null
  }
}

export default ExerciseComponent
